//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
export default {
  name: 'EditAgentAppDetail',
  components: { Drawer },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showJson: false,
      currentJson: '',
      jsonData: '{}',
      form: {
        name: '',
        description: '',
        type: '',
        id: '',
      },
      rules: {
        name: [{ required: true, message: '请输入应用名称', trigger: 'submit' }],
        type: [{ required: true, message: '请选择应用类型', trigger: 'submit' }],
        description: [{ required: true, message: '请填写描述', trigger: 'blur' }],
      },
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.form = {
          name: '',
          description: '',
          type: '',
          id: '',
        };
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close');
    },

    createAgentApp() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // createAgentApp
          this.$request({
            url: this.$api.createAgentApp,
            data: {
              agent_app: {
                ...this.form,
              },
            },
          }).then((res) => {
            console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
            // res
            console.log('%c Line:154 🥕 res', 'color:#42b983', res);
            this.$emit('refresh');
            this.close();
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
